// Dev-only filter to silence Chrome's ResizeObserver loop errors that spam the overlay
// These errors are benign during drag/resize animations and break DX without affecting functionality
if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
  const IGNORE_MESSAGES = [
    'ResizeObserver loop completed with undelivered notifications.',
    'ResizeObserver loop limit exceeded',
  ]

  // Stop propagation so webpack-dev-server overlay doesn't hijack the UI
  window.addEventListener(
    'error',
    e => {
      if (e && typeof e.message === 'string' && IGNORE_MESSAGES.includes(e.message)) {
        e.stopImmediatePropagation()
      }
    },
    true
  )

  // Filter console.error so logs remain clean during development
  const originalConsoleError = console.error
  console.error = (...args) => {
    try {
      if (
        args &&
        typeof args[0] === 'string' &&
        IGNORE_MESSAGES.some(msg => args[0].includes(msg))
      ) {
        return
      }
    } catch (_) {
      // noop
    }
    originalConsoleError(...args)
  }
}
